import { CoreEntity } from "./core-entity";

export interface Product extends CoreEntity{

}
